// Foundations
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

// Icons
import { faTimes } from '@fortawesome/free-solid-svg-icons';

// Services
import { AnalyticsService } from '../../../../services/analytics.service';

// Models
import { ReservationPetInfo } from 'src/app/models/reservation-pet-info.model';

@Component({
  selector: 'app-camp-details-dialog',
  templateUrl: './reservation-vaccine-dialog.component.html',
  styleUrls: ['./reservation-vaccine-dialog.component.scss'],
})
export class ReservationVaccineDialogComponent implements OnInit {
  // #region -> Property <-
  // ----------

  faTimes = faTimes;

  petList: ReservationPetInfo[];

  // ----------
  // #endregion

  /////////////////////////////

  constructor(
    private _analytics: AnalyticsService,
    private dialogRef: MatDialogRef<ReservationVaccineDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data
  ) {}

  // Life cycles
  // ------------------------------------------------------------------------------------

  ngOnInit(): void {
    this._prep();
  }

  // Public Methods
  // ------------------------------------------------------------------------------------

  close(): void {
    this._analytics.logButtonTap(
      'reservationRequest_closeExpiredVaccinationScreen'
    );

    this.dialogRef.close();
  }

  // #region -> Private <-
  // ----------

  private _prep() {
    //
    this.petList = this.data.petList;
  }

  // ----------
  // #endregion

  /////////////////////////////
}
